module.exports = __webpack_public_path__ + "static/media/fourthfloor.154ad51c.png";